import DynamicTitleWithTooltip from "../components/DynamicTitleWithTooltip";
import Form from "./Form";
import { Edit as RaEdit } from "react-admin";
import React from "react";
import useManageOpenEditTabs from "../components/useManageOpenEditTabs";

const getValueFilterTitle = (record, translate) =>
  `${translate("value-filter.label")} ${record.id} (${record.name})`;

const Edit = ({ translate, ...props }) => {
  const id = props.id?.toString(); // ID della risorsa
  useManageOpenEditTabs(props.resource, id);

  return (
    <RaEdit
      {...props}
      undoable={false}
      title={<DynamicTitleWithTooltip getTitle={getValueFilterTitle} />}
    >
      <Form />
    </RaEdit>
  );
};

export default Edit;
